import React, { useEffect, useRef, useState } from "react";
import { Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import "./Home.css"; // Import CSS file

import ClientCards from "./ClientCards";
import VideoSection from "./VideoSection";
import QuickLinks from "./QuickLinks";
import Carousel from "./Carousel";
import Benefits from "./Benefits";
import KeyFeatures from "./KeyFeatures";

const Home = () => {

  return (
    <>
      <Carousel />
      <VideoSection />
      <Benefits />
      <KeyFeatures />
      <QuickLinks />
      <ClientCards />
    </>
  );
};

export default Home;
